<div class="lg:pr-8 xl:pr-12">
  <h2 class="mt-5 mb-2 font-accent font-bold text-sm text-white">
    {{ title }}
  </h2>
  <app-block-list [blockIdList]="items"></app-block-list>
</div>
